import {
  Component, OnChanges, OnInit, AfterViewInit, AfterViewChecked, ElementRef, ViewEncapsulation,
  HostListener
} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UtilityService, AdobeAnalyticsService } from 'lib/ng2-sapmp/src/providers';
import { GridOptionsModel, ColumnDefinitionsModel, PaginationsModel } from 'lib/ng2-sapmp/src/ui-components/custom-grid';
import { SignupService } from './../shared/providers/signup.service';
import { ManageInventoryService } from './../../manage-inventory/shared/providers/manage-inventory.service';
import { StepIndicatorModel, StepIndicatorService } from 'lib/ng2-sapmp/src/ui-components';
import { SignUpModel, SignUpInputModel, SignUpOutputModel, AccountsModel, FanModel } from './../shared/models/signup.models';
import { HttpClient } from '@angular/common/http';
import { TabModel, TabComponent } from 'lib/ng2-sapmp/src/ui-components/tab';
// import { AccordionComponent } from 'lib/ng2-sapmp/src/ui-components/accordion/accordion.component';
import { PageLoaderService } from 'lib/ng2-sapmp/src/ui-components/page-loader';
import { SIGNUPDATA } from 'config';
import { BreadCrumbService } from 'lib/ng2-sapmp/src/ui-components/breadcrumb/breadcrumb.service';
import { MobilePivotModel } from 'lib/ng2-sapmp/src/ui-components/mobile-pivot';
import { MOBILEPIVOTS, TERMSCONDITIONS } from 'config';
import { ConfirmModalPopupModel } from 'lib/ng2-sapmp/src/ui-components/confirm-modal';
import { AccordionComponent, AccordionListComponent } from 'lib/ng2-sapmp/src/ui-components/accordion';

@Component({
  selector: 'app-accounts',
  templateUrl: './accounts.component.html',
  styleUrls: ['./accounts.component.scss'],
  providers: [SignupService, ManageInventoryService, AdobeAnalyticsService],
  encapsulation: ViewEncapsulation.None
})

export class AccountsComponent implements OnInit, AfterViewInit, AfterViewChecked {

  gridOptions: Array<GridOptionsModel>;
  stepIndicators: StepIndicatorModel[];
  confirmModalPopup: ConfirmModalPopupModel;
  stepSessionName: string;
  initModal: boolean;
  modalMsg: string;
  mailId: string;
  videoId: string;
  modalClass: string;
  initialSignup = false;
  backFromSettings = false;
  signupInputData: SignUpInputModel;
  signupOutputData: SignUpOutputModel;
  companyId: number;
  /* 1- Initial Signup, 2 - all 3 three tabs, 3 - 2 tab FANs, 4 - no tab only reveised FANs*/
  haveTab: boolean;
  activeTab: number;
  selectedFanList: number;
  tabArray: Array<any>;
  accordionList: boolean;
  pageTitle: string;
  pageDescription: string;
  pageLink: string;
  pageDescription2: string;
  accountsData: any;
  showError: boolean;
  errorMessage: string;
  showGoogleCreationError: boolean;
  dcmCodes = 'ABC_TNC_001';
  haveAccordion: boolean;
  eligibleFanCount: number;
  pivots: Array<MobilePivotModel>;
  termscondURl: any;
  termsCondproductURl: any;
  selected: any;
  eventEmit: any;
  title: any;
  supportArticle: any;
  showOverviewModal: boolean;
  selectedReviseSetup: boolean;
  private FANListSel: Array<FanModel> = [];
  private FANListAdd: Array<FanModel> = [];
  private FANListAct: Array<FanModel> = [];
  private FANListPro: Array<FanModel> = [];
  private FANListALL: Array<FanModel> = [];
  private successfullySignupFAN: Array<FanModel> = [];
  selectedFansCount: Array<number> = [];
  helpArticles: any;
  article: any;
  isMobile: any;
  termsCondi: any;
  staticTcUrl: any;
  guideUrl: any;
  MdmSelection: any;
  prodFlag: boolean;
  emmProductCode: any;
  tmc: any;
  kme: boolean;
  ztp: boolean;
  mdm: boolean;
  querytab: string;
  supportArticles: any;

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.mobileView();
  }



  constructor(private router: Router,
    private pageloaderService: PageLoaderService,
    private activatedRoute: ActivatedRoute,
    private signupService: SignupService,
    private manageInventoryService: ManageInventoryService,
    private utilityService: UtilityService,
    private http: HttpClient,
    private stepindicatorService: StepIndicatorService,
    private adobeAnalyticsService: AdobeAnalyticsService,
    private breadcrumb: BreadCrumbService,
    private el: ElementRef) {

    this.selected = { newSetupFanList: false, revisedFanList: false, awaitingSignupFanList: false };
    this.gridOptions = [];
    this.tabArray = [];
    this.activeTab = 0;
    this.haveTab = false;
    this.showGoogleCreationError = false;
    this.selectedReviseSetup = false;
    this.accountsData = {};
    this.accountsData.config = SIGNUPDATA.AccountsPage;
    this.pageloaderService.setPageLoaderStatus(false);

    const profileData = JSON.parse(sessionStorage.getItem('user'));
    this.mailId = profileData.user.emailAddress;
  }

  ngOnInit() {
    const mdmDetails = JSON.parse(sessionStorage.getItem('mdmDetails'));
    if (mdmDetails.productCode === 'ADDPMDM'){
      this.router.navigate(['/home']);
    }
    document.title = this.utilityService.getPageTitleConfig()[this.router.routerState.snapshot.url];
    console.log('Account page start time => ' + new Date().getTime());
    const previousRoute = sessionStorage.getItem('previousRoute');
    if (!sessionStorage.getItem('SignupBacktoCallingPage')) {
      sessionStorage.setItem('SignupBacktoCallingPage', previousRoute === '/productselection'
        || previousRoute === '/enrollmentTool' ? '/manageInventory' : previousRoute);
    }
    this.pivots = MOBILEPIVOTS.SIGNUPPAGE;
    const breadcrumbList = this.breadcrumb.getBreadCrumbs();
    if (breadcrumbList.length > 1) {
      this.pivots[0].routerLink = breadcrumbList[breadcrumbList.length - 2].routerLink;
    }

    this.stepindicatorService.setCurrentStep(this.activatedRoute.snapshot.url[0].path);
    this.stepindicatorService.setVisibility(true);
    this.pageDescription = '';
    /* T&C URL check here */
    this.termsCondproductURl = JSON.parse(sessionStorage.getItem('manage-product'));
    this.emmProductCode = this.termsCondproductURl.emmProductCode;
    if (this.emmProductCode === 'DMPSKME' || this.emmProductCode === 'DMPGZTP') {
      this.prodFlag = true;
    } else {
      this.prodFlag = false;
    }
    if (this.termsCondproductURl) {
      this.tmc = this.termsCondproductURl.emmProductCode;
    } else if (previousRoute === '/manageInventory/deviceInventory') {
      this.tmc = 'ADDPMDM';
    }
    if (this.tmc === 'ADDPMDM') {
      this.kme = false;
      this.ztp = false;
      this.mdm = true;
      this.termscondURl = TERMSCONDITIONS.URL.commonUrl;
      this.staticTcUrl = TERMSCONDITIONS.URL.addpmdmUrl;
      this.guideUrl = TERMSCONDITIONS.URL.commonUrl3;

    } else if (this.tmc === 'DMPGZTP') {
      this.kme = false;
      this.ztp = true;
      this.mdm = false;
      this.termscondURl = TERMSCONDITIONS.URL.commonUrl;
      this.staticTcUrl = TERMSCONDITIONS.URL.dmpgztpUrl;
    } else {
      this.kme = true;
      this.ztp = false;
      this.mdm = false;
      this.termscondURl = TERMSCONDITIONS.URL.commonUrl;
      this.staticTcUrl = TERMSCONDITIONS.URL.dmpskmeUrl;
    }
    // this.signupService.pageContent(this.utilityService.getEnvConfig().contentUrl.signup.accounts).
    //   subscribe(respobj => {
        // this.accountsData.content = respobj;
        this.accountsData.content = this.activatedRoute.snapshot.data.pageData.signupaccounts;
        this.accountsData.content.PopMsgSystemFailure.description =
          this.accountsData.content.PopMsgSystemFailure.description.replace('<mailId>', this.mailId);
        const signupData = this.signupService.getSignupModel();
        if (signupData) {
          /* Back from Settings */
          this.backFromSettings = true;
          this.signupInputData = signupData.inputModel;
          this.signupOutputData = signupData.outputModel;
          this.initialSignup = signupData.initialSignup;
          this.selectedFanList = this.selectedFanLength();
          if (this.signupOutputData.FANList.awaitingSignupFanList.length) {
            this.buildAccordion();
          } else {
            this.buildTabView();
            this.checkNDisableFANList();
          }
          this.pageloaderService.setPageLoaderStatus(true);
        } else {
          this.getFANList();
          this.backFromSettings = false;
        }
      // }, error => this.handleError(error, 'summary'));
      this.helpArticles = [{ id: 1, isActive: true, category: 'Help', description: '', ariaLabel:{
        'expand': 'Show help',
        'collapse': 'Hide help'
        }
        }];
    const pageName = 'signupAccountsPage';
    if (!this.prodFlag) {
      this.signupService.requestSupportContent(this.utilityService.getEnvConfig().getSupportDocument + pageName).
      subscribe(resp => {
      this.article = resp.supportArticles;
      this.supportArticle = true;
    }, (err) => {
       // this.handleError(err);
    });
    }
    this.signupService.createPageLoadProperties('ACCOUNTS', 'Accounts');
  }

  /*check mobile view for support article accordion*/
  mobileView() {
    this.helpArticles = [{ id: 1, isActive: !this.isMobile, category: 'Help', content: '' }];
  }


  ngAfterViewInit() {
    console.log('Account page end time => ' + new Date().getTime());
  }

  ngAfterViewChecked() {
    if (this.showError && !document.getElementById('alertMessage').classList.contains('msgShown')) {
      document.getElementById('alertMessage').scrollIntoView();
      document.getElementById('alertMessage').classList.add('msgShown');
    }
  }

  getTermsNConditiondata() {
    this.signupService.fetchJSON(this.utilityService.getEnvConfig().getTNC + '?dcmCodes=' + this.dcmCodes).
      subscribe(respobj => {
        this.signupOutputData.version = respobj.version ? respobj.version : '';
        sessionStorage.setItem('termsAndConditionContent', respobj.text);
      }, error => this.handleError(error, 'termsncondition'));
  }

  getSupportContent(articleNumber) {
    if (this.article.availableArticle[articleNumber].type === 'url') {
      this.initPopupModal(articleNumber);
    }
  }

  initPopupModal(articleNumber) {
    this.videoId = this.article.availableArticle[articleNumber].url;
    this.showOverviewModal = true;
  }
  closeOverviewModal() {
    this.showOverviewModal = false;
  }

  /* Getting all fan list*/
  getFANList() {
    console.log('Accounts Summary API request time => ' + new Date().getTime());
    this.signupService.getFANList(this.companyId).
      subscribe(respobj => {
        console.log('Accounts Summary API response time => ' + new Date().getTime());
        this.signupInputData = new SignUpInputModel(respobj.companyId);
        this.signupOutputData = new SignUpOutputModel(respobj.companyId);
        this.selectedFanList = this.selectedFanLength();
        this.signupInputData.FANList = respobj;
        this.signupOutputData.emmProductCode = respobj.emmProductCode;
        if (respobj.productCode === 'ADDPMDM') {
          this.initialSignup = false;
          this.signupInputData.FANList.awaitingSignupFanList = [];
        }

        // if (!respobj.awaitingSignupFanList.length) {
        //   this.handleError('error', 'fans');
        // }
        /* Check Fan Eligiblity here */
        const profileData = JSON.parse(sessionStorage.getItem('user'));
        console.log('Eligiblity check start time => ' + new Date().getTime());
        this.signupInputData.FANList.awaitingSignupFanList.forEach(item1 => {
          /*const selFan = profileData['user'].agreement.
            fans.filter(item2 => item2.fanId === item1.fanId);
          if (selFan.length) {
            item1.addpEligibleStatus = selFan[0].addpEligibility && selFan[0].addpEligibility === 'TRUE';
          } elseif(item1.addpEligibleStatus === undefined) {
            item1.addpEligibleStatus = false;
        }*/
        });
        console.log('Eligiblity check end time => ' + new Date().getTime());
        /* End Fan Eligiblity here */

        this.buildTabView();
        /* Show No Fan Eligiblity here */
        if (this.tabArray.length === 0 && this.eligibleFanCount === 0 &&
          this.querytab !== 'newSetupFanList' && this.querytab !== 'revisedFanList') {
          this.initModal = true;
          this.modalClass = 'pop-up';
          this.modalMsg = 'NoEligibleFAns';
          this.signupService.createPageLoadProperties('ACCOUNTSFAILURE', 'Accounts');
        }
        /* End Fan Eligiblity here */

        this.pageloaderService.setPageLoaderStatus(true);
        /*if (!this.utilityService.getEnvConfig().useMock) {
          this.getTermsNConditiondata();
        }*/
      }, error => this.handleError(error, 'fans'));
  }

  /* Review Based on the data ui have Tab or not*/
  buildTabView() {
    let tab = this.router['currentUrlTree'].queryParams.tab === undefined ? '' :
      this.router['currentUrlTree'].queryParams.tab;
    this.querytab = tab;
    this.signupInputData.FANList.awaitingSignupFanList = this.signupInputData.FANList.
      awaitingSignupFanList.filter((f) => { return f.addpEligibleStatus === true || f.addpEligibleStatus === undefined; });
    this.eligibleFanCount = this.signupInputData.FANList.awaitingSignupFanList.filter(item => item.addpEligibleStatus).length;

    let count = 0;
    let accountsDataConfig = this.accountsData.config;
    let awaitingSignupConfig;
    if (tab === 'awaitingSignupFanList' && sessionStorage.getItem('previousRoute') === '/enrollmentTool' ||
      (sessionStorage.getItem('previousRoute') === '/productselection' &&
        ((this.termsCondproductURl.emmProductCode === 'DMPGZTP' || this.termsCondproductURl.emmProductCode === 'DMPSKME')))) {
      //(<any>Object).values(accountsDataConfig).filter((f) => {
        //if (f.name === 'Add accounts') {
          //awaitingSignupConfig = f;
        //}
      //});
      accountsDataConfig = {
        awaitingSignupFanList: accountsDataConfig.awaitingSignupFanList
      };
      tab = undefined;
    }
    for (const fanType in accountsDataConfig) {
      if (this.signupInputData.FANList[fanType].length && (fanType !== 'awaitingSignupFanList' ||
        (fanType === 'awaitingSignupFanList' && this.eligibleFanCount !== 0))) {
        this.initGrid(this.signupInputData.FANList[fanType], this.accountsData.config[fanType].columnDefinitions,
          fanType !== 'awaitingSignupFanList' ? this.accountsData.config[fanType].rowDisable :
            this.eligibleFanCount !== this.signupInputData.FANList.awaitingSignupFanList.length,
          this.accountsData.config[fanType].rowDisableCondition,
          this.accountsData.config[fanType].rowDisableConditionInverse,
          fanType, tab === fanType);
        this.tabArray.push({
          id: this.accountsData.config[fanType].name, name: fanType,
          isActive: (tab === fanType || tab === '' && count === 0), htmlFlag: '', description: ''
        });
        count++;
      }
    }
    if (this.tabArray.length > 1) {
      if (this.tmc === 'ADDPMDM') {
        this.haveTab = true;
      } else {
        this.haveTab = false;
      }

      if (this.tabArray.filter(item => item.isActive).length === 0) {
        this.tabArray[0].isActive = true;
      }
    }

    this.initialSignup = this.tabArray.length === 1 && this.tabArray[0].name === 'awaitingSignupFanList';
    this.setAccountsHelpMessage();

    if (this.initialSignup) {
      this.signupInputData.FANList.awaitingSignupFanList.map(fan => {
        if (fan.addpEligibleStatus) {
          fan.selected = true;
        }
        return fan;
      });
      this.onRowClick('');
    }
  }

  buildAccordion() {
    let categoryNumber: string;
    if (this.signupOutputData.FANList.awaitingSignupFanList.length) {
      this.signupInputData.FANList.awaitingSignupFanList = this.signupOutputData.FANList.awaitingSignupFanList.slice();
      this.initGrid(this.signupInputData.FANList.awaitingSignupFanList.slice(),
        this.accountsData.config.awaitingSignupFanList.columnDefinitions,
        this.accountsData.config.awaitingSignupFanList.rowDisable,
        this.accountsData.config.awaitingSignupFanList.rowDisableCondition,
        this.accountsData.config.awaitingSignupFanList.rowDisableConditionInverse,
        'awaitingSignupFanList');
      categoryNumber = this.selectedFanList > 1 ? ' foundation accounts added' : ' foundation account added';
      this.tabArray.push({
        id: 1, name: 'awaitingSignupFanList', isActive: false,
        category: this.selectedFanList + categoryNumber, content: '',
        ariaLabel: this.accountsData.content.accordionAriaLabel
      });
    }
    this.haveAccordion = true;
    this.setAccountsHelpMessage();
  }

  initGrid(respobj, colDef: Array<ColumnDefinitionsModel>, disableRow: boolean, disableRowCondition,
    disableRowConditionInverse, callback, preselectTab?) {
    const options = new GridOptionsModel();
    options.enableFiltering = false;
    options.enableSorting = false;
    options.multiSelect = true;
    options.emptyMessage = 'No records';
    options.enableBackLink = true;
    options.ariaLabel = 'Select all foundation accounts.';
    options.backLinkText = 'View all accounts';
    options.emptyMessage = 'We didn\'t find any foundation accounts that match your search. Did you enter a full account number? ' +
      'Check the number and try again.';
    if (disableRow) {
      options.disableRow = true;
      options.disableRowCondition = disableRowCondition;
      options.disableRowConditionInverse = disableRowConditionInverse;
    }

    const preSelectedFan = sessionStorage.getItem('selectedFAN');
    if (preselectTab && preSelectedFan) {
      const selectedFan: FanModel = respobj.filter(fan => fan.fanId === preSelectedFan)[0];
      if (selectedFan && selectedFan.accountStatus && selectedFan.accountStatus.toUpperCase() === 'ACTIVE') {
        selectedFan.selected = true;
        this.accountsData.content.selectedFans = this.accountsData.content.selectedFanTmp.replace('<selectedFanCount>', 1);
        this.accountsData.content.selectedFans = this.accountsData.content.selectedFans.replace('<account/accounts>',
          'account');
        this.selected['revisedFanList'] = true;
        this.signupInputData.FANList.revisedFanList.forEach(item1 => {
          if (item1.fanId === selectedFan.fanId) {
            item1.selected = true;
          }
        });
        this.signupOutputData.FANList['revisedFanList'] =
          this.signupInputData.FANList['revisedFanList'].filter(item => item.selected === true);
        this.selectedFanList = 1;
        this.gridOptions.forEach((data, index) => {
          data.disableGrid = true;
        });
        this.selectedReviseSetup = true;
      }
    }

    const mdmDetails = JSON.parse(sessionStorage.getItem('mdmDetails'));
    if (callback === 'revisedFanList') {
      options.callbacks = { showFansProfile: this.showFansProfile };
      respobj.filter((fan) => {
        fan.accountSubStatus = SIGNUPDATA.statusLabel[fan.accountStatus];
        if (fan.accountStatus === 'ACTIVE' && fan.newDeviceEffectiveDate && new Date(fan.newDeviceEffectiveDate) > new Date()) {
          fan.accountSubStatus = 'Added';
        }
      });
      respobj.filter((fan) => {
        if (fan.selected) {
          this.FANListSel.push(fan);
        } else if (fan.accountSubStatus === 'Added') {
          this.FANListAct.push(fan);
        } else if (fan.accountSubStatus === 'Active') {
          this.FANListAct.push(fan);
        } else if (fan.accountSubStatus === 'Processing') {
          this.FANListPro.push(fan);
        }
      });
      respobj = this.FANListALL.concat(this.FANListSel, this.FANListAdd, this.FANListAct, this.FANListPro);
    } else if (callback === 'awaitingSignupFanList') {
      options.callbacks = { fanEligiblityStatus: this.fanEligiblityStatus };
    } else if (callback === 'newSetupFanList' && mdmDetails !== null && mdmDetails.productCode === 'ADDPZTE') {
      // making use of exiting variable to store google enrolled fans
      this.FANListSel = [];
      // using for samsung enrolled fans
      this.FANListPro = [];
      this.FANListALL = [];
      respobj.filter((fan) => {
        if (fan.productCode === 'DMPGZTP' && fan.productCode === this.termsCondproductURl.emmProductCode) {
          this.FANListSel.push(fan);
        } else if (fan.productCode === 'DMPSKME' && fan.productCode === this.termsCondproductURl.emmProductCode) {
          this.FANListPro.push(fan);
        }
      });
      respobj = this.FANListALL.concat(this.FANListSel, this.FANListPro);
    }

    const pagination = {
      recordsPerPage: 20,
      currentPage: 1,
      isServerSide: false,
      totalRecords: respobj.length
    };

    if (respobj.length > 20) {
      options.enableFiltering = true;
      options.enableSorting = true;
    }
    options.Paginations = pagination;


    options.gridData = respobj;
    options.columnDefinitions = colDef;
    options.searchPlaceHolder = 'Enter full foundation account number';
    options.searchType = 'number';
    this.gridOptions.push(options);
  }

  showFansProfile(element, row, field, currentElem, type) {
    if (type === 'template') {
      let pName = row.profileName;
      if (row.profileName === undefined || row.profileName == null) {
        pName = 'Profile unavailable';
      }
      return `<div>${row.fanId}</div>`
      // return `<div>${row.fanId}</div><a tabindex="0" aria-label="Select checkbox for" title="Select checkbox for" class='fan-profile' title="Select checkbox for">${pName}</a>`;;
    } else if (row.accountStatus === 'ACTIVE' && type.target.classList.contains('fan-profile')) {
      currentElem.onDataChange.emit({ data: row, type: 'profileInfo' });
    }
  }

  fanEligiblityStatus(element, row, field, currentElem) {
    return `<div class="${row.addpEligibleStatus ? 'eligible-fans' : 'ineligible-fans'}">${row.fanId}</div>`;
  }

  /* Set Active Tab*/
  selectedTab(data) {
    this.activeTab = data;
    this.setAccountsHelpMessage();
  }

  /* Fan selection watched here from Grid*/
  onRowClick(action) {

    const fanType = this.tabArray[this.activeTab].name;

    this.signupOutputData.FANList[fanType] = this.signupInputData.FANList[fanType].filter(item => item.selected === true);

    this.selectedFanList = this.selectedFanLength();

    this.checkNDisableFANList();

    if (action.type === 'profileInfo') {
      this.manageInventoryService.setSelectedProfileID(action.data.profileId);
      this.router.navigate(['manageInventory/fanDeploymentProfile']);
    }
  }

  /* One Fan List is selected other list disabled*/
  checkNDisableFANList() {
    this.gridOptions.forEach((data, index) => {
      data.disableGrid = !!this.selectedFanList && !this.signupOutputData.FANList[this.tabArray[index].name].length;
    });
  }

  /* Show Selected FAN's in html*/
  selectedFanLength() {
    const selFans = [];
    for (const fanType in this.accountsData.config) {
      if (this.signupOutputData.FANList[fanType].length !== 0) {
        this.selected[fanType] = true;
      } else {
        this.selected[fanType] = false;
      }
      if (this.signupOutputData.FANList[fanType].length) {
        this.signupOutputData.FANList[fanType].forEach(cols => selFans.push(cols.fanId));
      }
    }
    this.accountsData.content.selectedFans = this.accountsData.content.selectedFanTmp.replace('<selectedFanCount>', selFans.length);
    this.accountsData.content.selectedFans = this.accountsData.content.selectedFans.replace('<account/accounts>',
      selFans.length === 0 ? 'accounts' : selFans.length > 1 ? 'accounts' : 'account');
    this.selectedFansCount[ this.activeTab ] = this.accountsData.content.selectedFans;
    return selFans.length;
  }

  setAccountsHelpMessage() {
    if (this.initialSignup && this.backFromSettings) {
      this.pageTitle = this.accountsData.content['backFromSettings'].heading;
      this.pageDescription = this.accountsData.content['backFromSettings'].description;
    } else if (this.tabArray.length === 0 && this.eligibleFanCount === 0) {
      if (this.mdm) {
        this.pageTitle = this.accountsData.content['noTabawaitingSignupFanList'].heading;
        this.pageDescription = this.accountsData.content['noTabawaitingSignupFanList'].description;
        this.pageLink = this.accountsData.content['noTabawaitingSignupFanList'].link;
        this.pageDescription2 = this.accountsData.content['noTabawaitingSignupFanList'].description2;
        if (window.innerWidth <= 1024) {
          this.pageDescription = this.accountsData.content['noTabawaitingSignupFanList'].mobileDescription;
          this.accountsData.content['noTabawaitingSignupFanList'].ibmTerms2 =
            this.accountsData.content['noTabawaitingSignupFanList'].ibmTerms2Mobile;
          this.accountsData.content['noTabawaitingSignupFanList'].ibmServiceLink =
            this.accountsData.content['noTabawaitingSignupFanList'].ibmServiceMobileLink;
        }
      } else {
        this.pageTitle = this.accountsData.content['noTabawaitingSignupFanList'].heading;
        this.pageDescription = this.accountsData.content['noTabawaitingSignupFanList'].description1;
      }
    } else {
      if (this.mdm === true) {
        this.pageTitle = this.accountsData.content[(this.haveTab ? 'tab' : 'noTab') +
          this.tabArray[this.activeTab].name].heading;
        this.pageDescription = this.accountsData.content[(this.haveTab ? 'tab' : 'noTab') +
          this.tabArray[this.activeTab].name].description;
        this.pageLink = this.accountsData.content[(this.haveTab ? 'tab' : 'noTab') +
          this.tabArray[this.activeTab].name].link;
        this.pageDescription2 = this.accountsData.content[(this.haveTab ? 'tab' : 'noTab') +
          this.tabArray[this.activeTab].name].description2;
      } else {
        this.pageTitle = this.accountsData.content['noTabawaitingSignupFanList'].heading;
        this.pageDescription = this.accountsData.content['noTabawaitingSignupFanList'].description1;
      }
      const fanType = 'awaitingSignupFanList'; // this.tabArray[this.activeTab].name;
      if (!this.selectedReviseSetup) {
        const selFansLength = this.signupOutputData.FANList[fanType].length;
        this.accountsData.content.selectedFans = this.accountsData.content.selectedFanTmp.replace('<selectedFanCount>', selFansLength);
        this.accountsData.content.selectedFans = this.accountsData.content.selectedFans.replace('<account/accounts>',
          selFansLength === 0 ? 'accounts' : selFansLength > 1 ? 'accounts' : 'account');
      } else {
        this.checkNDisableFANList();
      }
    }
  }

  handleError(error, type) {
    if (type === 'summary') {
      this.initModal = true;
      this.modalClass = 'pop-up';
      this.modalMsg = 'SystemFailure';
      this.pageloaderService.setPageLoaderStatus(true);
    } else {
      this.showError = true;
      this.pageloaderService.setPageLoaderStatus(true);
      this.errorMessage = this.accountsData.content.errorMessages[type];
      if (document.getElementById('alertMessage')) {
        document.getElementById('alertMessage').classList.remove('msgShown');
      }
    }
  }

  backToInitialSetup(event) {
    event.preventDefault();
    this.signupService.removeSignupModel();
    this.breadcrumb.removeLastBreadCrumb();
    sessionStorage.removeItem('enrollmentSelectedDetails');
    sessionStorage.removeItem('savedSelectedDetails');
    const currentUrl = this.breadcrumb.getLastUrlFromBreadCrumb().routerLink;
    const unclaim = sessionStorage.getItem('unclaimFlag') ? JSON.parse(sessionStorage.getItem('unclaimFlag')) : false;
    if (unclaim) {
      const previousUrl = sessionStorage.getItem('currentRoute');
      this.router.navigate([previousUrl]);
    } else {
      this.router.navigate([currentUrl]); 
    }
  }

  backToProductSelection(event) {
    event.preventDefault();
    const previousRoute = sessionStorage.getItem('previousRoute');
    this.router.navigate([previousRoute]);
  }

  handleSuccessResponse(resobj) {
    console.log('Signup API response time => ' + new Date().getTime());
    if(resobj.status === 'Failed') {
      this.signupService.saveSignupModel(this.signupInputData, this.signupOutputData, this.initialSignup);
      this.handleError('error', 'signup');
    } else if (((resobj.status === 'Paritial Failed' || resobj.status === 'success') && this.tmc !== 'ADDPMDM') || this.tmc === 'ADDPMDM') {
      if (resobj.status === 'Paritial Failed') {
        let successFanList = resobj.successFanList;
        this.signupOutputData.FANList.awaitingSignupFanList.filter(item => {
          successFanList.filter(f => {
            if(item.fanId === f.fanId) {
              this.successfullySignupFAN.push(item);
            }
          });
        });
        this.signupOutputData.FANList.awaitingSignupFanList = this.successfullySignupFAN;
      }
      this.signupService.saveSignupModel(this.signupInputData, this.signupOutputData, this.initialSignup);
      // Adobe Analytics Starts
      this.adobeAnalyticsService.createAdobeEventProperties('MANAGE_DEVICE', 'SUCCESS', 'formResponse',
        'BC_Device_Signup_Continue_Submit', 'success', 'Success_Admit', 'Continue', 'Body', '/businessconsole/signup/settings');
      // const data = { code: 'device_signup_continue_submit', errorType: 'SUCCESS_TYPE', successFlag: 1, msg: '' };
      // this.adobeAnalyticsService.trackEventProperties(data);
      // Ends
      this.router.navigate(['/signup/settings']);
    }
  }

  continueToNext() {
    this.adobeAnalyticsService.createAdobeEventProperties('MANAGE_DEVICE', 'SUCCESS', 'formSubmit',
      'BC_Device_Signup_Continue_Submit', 'success', 'Success_Admit', 'Continue', 'Body', '/businessconsole/signup/settings');
    const checkFANSelected = this.signupOutputData.FANList.awaitingSignupFanList.length ||
      this.signupOutputData.FANList.newSetupFanList.length ||
      this.signupOutputData.FANList.revisedFanList.length;

    const manageProduct = JSON.parse(sessionStorage.getItem('manage-product'));
    const emmProductCode = manageProduct.emmProductCode;
    const selectedAccID = manageProduct.selectedAccID;
    const selectedId = Number.parseInt(selectedAccID);
    const user = JSON.parse(sessionStorage.getItem('user'));
    const agreementID = user.user.agreement.id;
    const impersonator = JSON.parse(sessionStorage.getItem('impersonator'));
    const isDisabled = impersonator && impersonator.id ? true : false;

    if (!checkFANSelected) {
      this.showError = true;
      this.errorMessage = this.accountsData.content[(this.haveTab ? 'tab' : 'noTab') +
        this.tabArray[this.activeTab].name].errorMessage;
    } else {
      this.showError = false;
      if (isDisabled && this.signupOutputData.FANList.awaitingSignupFanList.length && !this.haveAccordion) {
        (<HTMLInputElement>document.getElementById('accounts-btn')).disabled = true;
      } else if (this.signupOutputData.FANList.awaitingSignupFanList.length && !this.haveAccordion &&
        !this.utilityService.getEnvConfig().useMock) {
        this.pageloaderService.setPageLoaderStatus(false);
        if (emmProductCode === 'DMPGZTP') {
          if (Number.isInteger(selectedId)) {
            // already have the unqui code for google account
            console.log('Signup API request time => ' + new Date().getTime());
            this.signupService.submitSignupOrder(this.signupService.getSignupDataFromModel(this.signupOutputData)).subscribe(resobj => {
              this.handleSuccessResponse(resobj);
            }, error => {
              // this.pageloaderService.setPageLoaderStatus(true);
              this.signupService.saveSignupModel(this.signupInputData, this.signupOutputData, this.initialSignup);
              this.handleError(error, 'signup');
              // this.router.navigate(['/signup/settings']);
              // Adobe Analytics Starts
              this.adobeAnalyticsService.createAdobeEventProperties('MANAGE_DEVICE', 'FAILURE', 'formResponse',
                'BC_Device_Signup_Continue_Submit', 'SystemFailure',
                'Failure_user', 'Continue', 'Body', '/businessconsole/signup/accounts');
              // const data = { code: 'device_signup_continue_submit', errorType: 'FAILURE_TYPE', successFlag: 0, msg: error.statusText };
              // this.adobeAnalyticsService.trackEventProperties(data);
              // Ends
            });

          } else {
            this.signupService.createZtpAccount(selectedAccID, agreementID)
              .subscribe(response => {
                if (response.status === 'success') {
                  sessionStorage.removeItem('manage-product');
                  let productDetails = { emmProductCode: '', selectedAccID: '', signupEmmStatus: '' };
                  productDetails.emmProductCode = 'DMPGZTP';
                  productDetails.selectedAccID = response.ztpId;
                  productDetails.signupEmmStatus = 'initial';
                  sessionStorage.setItem('manage-product', JSON.stringify(productDetails));
                  sessionStorage.removeItem('savedSelectedDetails');
                  sessionStorage.removeItem('enrollmentSelectedDetails');
                  sessionStorage.removeItem('showGoogleCreationError');
                  // Success scenario
                  console.log('Signup API request time => ' + new Date().getTime());
                  this.signupService.submitSignupOrder(
                    this.signupService.getSignupDataFromModel(this.signupOutputData)).subscribe(resobj => {
                      this.handleSuccessResponse(resobj);
                    }, error => {
                      // this.pageloaderService.setPageLoaderStatus(true);
                      // this.handleError(error, 'summary');
                      this.signupService.saveSignupModel(this.signupInputData, this.signupOutputData, this.initialSignup);
                      this.handleError(error, 'signup');
                      // Adobe Analytics Starts
                      this.adobeAnalyticsService.createAdobeEventProperties('MANAGE_DEVICE', 'FAILURE', 'formResponse',
                        'BC_Device_Signup_Continue_Submit', 'SystemFailure',
                        'Failure_user', 'Continue', 'Body', '/businessconsole/signup/accounts');
                      // Ends
                    });

                } else {
                  this.pageloaderService.setPageLoaderStatus(true);
                  // event.preventDefault();
                  const previousRoute = sessionStorage.getItem('previousRoute');
                  sessionStorage.setItem('showGoogleCreationError', 'true');
                  this.router.navigate([previousRoute]);
                }
              });
          }
        } else {
          console.log('Signup API request time => ' + new Date().getTime());
          this.signupService.submitSignupOrder(this.signupService.getSignupDataFromModel(this.signupOutputData)).subscribe(resobj => {
            this.handleSuccessResponse(resobj);
          }, error => {
            // this.pageloaderService.setPageLoaderStatus(true);
            // this.handleError(error, 'summary');
            this.signupService.saveSignupModel(this.signupInputData, this.signupOutputData, this.initialSignup);
            this.handleError(error, 'signup');
            // Adobe Analytics Starts
            this.adobeAnalyticsService.createAdobeEventProperties('MANAGE_DEVICE', 'FAILURE', 'formResponse',
              'BC_Device_Signup_Continue_Submit', 'SystemFailure', 'Failure_user', 'Continue', 'Body', '/businessconsole/signup/accounts');
            // const data = { code: 'device_signup_continue_submit', errorType: 'FAILURE_TYPE', successFlag: 0, msg: error.statusText };
            // this.adobeAnalyticsService.trackEventProperties(data);
            // Ends
          });
        }
      } else {
        // Adobe Analytics Starts
        this.adobeAnalyticsService.createAdobeEventProperties('MANAGE_DEVICE', 'SUCCESS', 'formResponse',
          'BC_Device_Signup_Continue_Submit', 'success', 'Success_Admit', 'Continue', 'Body', '/businessconsole/signup/settings');
        // const data = { code: 'device_initial_signup_submit', errorType: 'SUCCESS_TYPE', successFlag: 1, msg: '' };
        // this.adobeAnalyticsService.trackEventProperties(data);
        // Ends
        this.signupService.saveSignupModel(this.signupInputData, this.signupOutputData, this.initialSignup);
        this.router.navigate(['/signup/settings']);
      }
    }
  }
}
